<div class="table-container">
	<h4 class="text-primary">{{ title }}</h4>
	<p-table
		#table
		[value]="data"
		[rows]="rows"
		[selectionMode]="selectionMode"
		[(selection)]="selectedData"
		[rowsPerPageOptions]="rowsPerPageOptions"
		[loading]="loading"
		[scrollable]="scrollable"
		[scrollHeight]="scrollHeight"
		[globalFilterFields]="globalFilterFields"
		(onEditInit)="onEditInit($event)"
		(onEditComplete)="onEditComplete($event)"
		[paginator]="paginator"
		[lazy]="lazyMode"
		[totalRecords]="dataLength"
		[first]="first"
		(onLazyLoad)="onLazyLoad($event)"
		(onSort)="onSort($event)"
		[filters]="filters"
		[sortField]="sortField"
		[sortOrder]="sortOrder"
		[styleClass]="styleClass"
	>
		<!-- <ng-template *ngIf="globalFilterFields.length" pTemplate="caption">
            <div class="flex">
                <p-iconField iconPosition="left" class="ml-auto">
                    <p-inputIcon>
                        <i class="pi pi-search"></i>
                    </p-inputIcon>
                    <input
                        pInputText
                        type="text"
                        (input)="onGlobalFilter($event, 'contains')"
                        placeholder="Search keyword"
                        class="pl-5"
                        style="min-width: 150px"
                    />
                </p-iconField>
            </div>
        </ng-template> -->

		<ng-template pTemplate="header">
			<tr>
				<th *ngFor="let col of columns" [pSortableColumn]="col.field">
					<div class="flex justify-content-between align-items-center">
						{{ col.header }}
						<p-sortIcon [field]="col.field"></p-sortIcon>
					</div>
				</th>
				<th *ngIf="actions.length">Actions</th>
			</tr>
			<tr *ngIf="enabledColFilters">
				<th *ngFor="let col of columns">
					<ng-container [ngSwitch]="customFilterComponents[col.field]">
						<!-- DROPDOWN -->
						<ng-container *ngSwitchCase="'dropdown'">
							<p-columnFilter
								*ngIf="customFilterComponents[col.field] === 'dropdown'"
								[field]="col.field"
								matchMode="equals"
								[showMenu]="false"
							>
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-dropdown
										[ngModel]="value"
										[options]="dropdownOptions[col.field] || []"
										(onChange)="filter($event.value)"
										placeholder="All"
										optionLabel="label"
										optionValue="value"
										appendTo="body"
									></p-dropdown>
								</ng-template>
							</p-columnFilter>
						</ng-container>

						<!-- DEFAULT INPUT -->
						<ng-container *ngSwitchDefault>
							<p-columnFilter
								[field]="col.field"
								[matchMode]="'contains'"
								[placeholder]="col.filterPlaceholder || 'Search by ' + col.header"
								[type]="'text'"
							>
							</p-columnFilter>
						</ng-container>
					</ng-container>
				</th>
				<th *ngIf="actions.length"></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rowData>
			<tr>
				<td
					*ngFor="let col of columns"
					[pEditableColumn]="rowData[col.field]"
					pEditableColumnField="{{ col.field }}"
				>
					<!-- Link Column -->
					<ng-container
						*ngIf="col.link && col.link.field && col.field === col.link.field; else otherContent"
					>
						<a [routerLink]="[col.link.route, rowData[col.field]]" target="_blank">
							{{ rowData[col.field] }}
						</a>
					</ng-container>

					<!-- Other Column Content -->
					<ng-template #otherContent>
						<!-- Image Column -->
						<ng-container *ngIf="imageColumns.includes(col.field); else displayOnly">
							<img
								[src]="rowData[col.field]"
								alt="Product Image"
								width="60"
								class="pointer"
								[ngClass]="{ 'shadow-4': rowData[col.field] !== '' }"
								(click)="onImgClicked(rowData.imgFull)"
								cursor="pointer"
							/>
						</ng-container>

						<!-- Display Only -->
						<ng-template #displayOnly>
							<!-- Markdown/HTML Column (e.g. links in Details) -->
							<ng-container *ngIf="htmlColumns.includes(col.field); else nonHtmlContent">
								<span [innerHTML]="renderHtml(rowData[col.field])"></span>
							</ng-container>

							<ng-template #nonHtmlContent>
								<!-- for cols with multiple fields -->
								<ng-container *ngIf="col.icon; else editOrDisplay">
									<!-- for multiple icons in one col -->
									<ng-container *ngIf="col.fields.length !== 0; else displaySingleIcon">
										<ng-container *ngFor="let field of col.fields">
											<ng-container
												*ngIf="getIconAndTooltip(field, rowData[field]) as iconTooltip"
											>
												<i
													[class]="iconTooltip.icon"
													pTooltip="{{ iconTooltip.tooltip }}"
													tooltipPosition="top"
													style="font-size: 1.5rem; margin-right: 0.5rem; cursor: pointer"
												>
												</i>
											</ng-container>
										</ng-container>
									</ng-container>

									<!-- for col with single icon-->
									<ng-template #displaySingleIcon>
										<ng-container
											*ngIf="getIconAndTooltip(col.field, rowData[col.field]) as iconTooltip"
										>
											<i
												[class]="iconTooltip.icon"
												pTooltip="{{ iconTooltip.tooltip }}"
												tooltipPosition="top"
												style="font-size: 1.5rem; cursor: pointer"
											>
											</i>
										</ng-container>
									</ng-template>
								</ng-container>

								<ng-template #editOrDisplay>
									<ng-container *ngIf="editableFields.includes(col.field); else nonEditable">
										<p-cellEditor>
											<ng-template pTemplate="input">
												<input pInputText type="text" [(ngModel)]="rowData[col.field]" />
											</ng-template>
											<ng-template pTemplate="output">
												{{ rowData[col.field] }}
											</ng-template>
										</p-cellEditor>
									</ng-container>
								</ng-template>

								<ng-template #nonEditable>
									<ng-container *ngIf="col.format; else noFormat">
										<span>{{ rowData[col.field] | date: col.format }}</span>
									</ng-container>
									<ng-template #noFormat>
										<span>{{ rowData[col.field] | capitalizeUnderscore }}</span>
									</ng-template>
								</ng-template>
							</ng-template>
						</ng-template>
					</ng-template>
				</td>

				<!--TODO: still in development-->
				<td *ngIf="actions.length" class="actions-cell">
					<button
						*ngFor="let action of actions"
						pButton
						type="button"
						[icon]="action.icon"
						(click)="action.callback(rowData)"
						[label]="action.label"
						[rounded]="true"
						[severity]="action.severity || null"
						class="p-button-text"
					></button>
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="7">
					<p-messages
						*ngIf="data && data.length === 0"
						[value]="[{ severity: 'info', detail: errorMessage }]"
					/>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
